<template>
  <div>
    <v-layout row class="mt-3">
      <v-flex xs10 sm4 md3>
        <v-select
          :items="column_items"
          item-value="value"
          v-model="sort_column"
          @change="sortBy()"
          label="Sort by"
          color="black"
          clearable
          hide-details
        ></v-select>
      </v-flex>
      <v-flex xs2 sm4 md3>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'asc'"
          :disabled="asc_desc == 'desc' || sort_column == 'no_default'"
          @click="selectAscDesc('desc')"
        >
          <v-icon small>arrow_downward</v-icon>
        </v-btn>
        <v-btn
          icon
          dark
          class="sort-btn mt-3"
          v-if="sort_column != 'no_default' && asc_desc == 'desc'"
          :disabled="asc_desc == 'asc' || sort_column == 'no_default'"
          @click="selectAscDesc('asc')"
        >
          <v-icon small>arrow_upward</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="extra_credit_zone_report_list"
      class="elevation-1 mt-4"
      style="background-color:white;padding:10px; border-radius:10px;"
    >
      <template
        slot="headerCell"
        slot-scope="props"
        style="background-color:black;"
      >{{ props.header.text }}</template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ extra_credit_zone_report_list.indexOf(props.item)+1 }}</td>
        <td>{{ props.item.order_code }}</td>
        <td>{{ props.item.remark }}</td>
        <td class="text-xs-center">{{ props.item.date }}</td>
        <td>{{ props.item.rider }}</td>
        <td
          class="text-xs-right"
        >{{ props.item.point ? (parseFloat(props.item.point).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}</td>
        <td>{{ props.item.note }}</td>
      </template>
      <template slot="footer" style="border:none;">
        <td></td>
        <td colspan="3" class="text-xs-center">
          <strong>
            <br>Total credit point
            <br>&nbsp;
          </strong>
        </td>
        <td></td>
        <td class="text-xs-right">
          <br>
          {{extra_credit_zone_report_summary.point ? (parseFloat(extra_credit_zone_report_summary.point).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}}
          <br>&nbsp;
        </td>
        <td></td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "No.",
          align: "center",
          sortable: false,
          value: "name"
        },
        { text: "Order code", value: "id", sortable: false },
        {
          text: "Remark zone",
          value: "remark_zone",
          sortable: false,
          align: "center"
        },
        {
          text: "Date/Time",
          value: "date_time",
          sortable: false,
          align: "center"
        },
        { text: "Rider", value: "rider", sortable: false },
        {
          text: "Credit point",
          value: "credit_point",
          sortable: false,
          align: "center"
        },
        { text: "Note", value: "note", sortable: false, align: "center" }
      ],
      column_items: [{ text: "Rider", value: "rider", sortable: false }],
      asc_desc: "asc",
      sort_column: "no_default",
      isSort: false
    };
  },
  watch: {
    extra_credit_zone_report_list() {
      if (this.isSort == false) {
        this.asc_desc = "asc";
        this.sort_column = "no_default";
      }
    }
  },
  computed: {
    ...mapState({
      extra_credit_zone_report_list: state =>
        state.fetchExtraCreditReport.extra_credit_zone_report_list,
      extra_credit_zone_report_summary: state =>
        state.fetchExtraCreditReport.extra_credit_zone_report_summary
    })
  },
  methods: {
    async sortBy() {
      if (this.sort_column == undefined) {
        this.sort_column = "no_default";
        this.asc_desc = "asc";
      }

      this.isSort = true;
      const send_json_data = {
        data: this.extra_credit_zone_report_list,
        field: this.sort_column,
        asc_desc: this.asc_desc
      };

      await this.$store.dispatch("sortData", send_json_data);
      await this.$store.commit("fetchExtraCreditReport/getExportReportForm");
      this.$store.commit("fetchExtraCreditReport/getExportSummary");
      this.isSort = false;
    },
    selectAscDesc(value) {
      this.asc_desc = value;
      this.sortBy();
    }
  }
};
</script>
<style scoped>
.sort-btn {
  cursor: pointer;
  height: 30px;
  width: 30px;
  background-color: #fafafa;
  border: 1px solid #b8b8b8;
  border-radius: 10px;
  color: #757575;
  margin-top: 10px;
  margin-left: 20px;
}
/* .main-title {
  font-size: 22px;
  font-weight: bold;
}
.text-table {
  font-weight: bold;
  line-height: 30px;
}
.title-store {
  font-size: 19px;
  font-weight: bold;
} */
</style>

